import { render, staticRenderFns } from "./AutomationTabButtonEditor.vue?vue&type=template&id=24ca3916&"
import script from "./AutomationTabButtonEditor.vue?vue&type=script&lang=js&"
export * from "./AutomationTabButtonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports